import { Row } from 'react-bootstrap';
import Spinner from 'react-bootstrap/Spinner';
import "./TextLoader.css";

/**
 * Creates a loader with an upper and lower message to give feedback to final user.
 * @param {{upperMessage: string, lowerMessage: string}} props 
 * @returns 
 */
export default function TextLoader(props) {

  const bigSpace = () => {
    return (
      <>
        <Row />
        <Row />
        <Row />
        <Row />
      </>
    )
  }

  return (
    <Row>
      <Row>
        <div className='text-loader-text'>
          {props.upperMessage}
        </div>
      </Row>

      {bigSpace()}

      <Row className='justify-content-md-center'>
        <Spinner className='big-icon' animation='border' />
      </Row>

      {bigSpace()}

      <Row>
        <div className='text-loader-text'>
          {props.lowerMessage}
        </div>
      </Row>
    </Row>
  )
}